import {
  OutlinedInput,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { useEffect } from "react";
import HeaderCell from "./TableComponents/HeaderCell";
import { flexRender } from "@tanstack/react-table";
const TableHeader = (props) => {
  const { table } = props;
  const headerGroups = table.getHeaderGroups();
  const headersArray = headerGroups
    .map((headerGroup) => headerGroup.headers)
    .flatMap((el) => el);
  useEffect(() => {
    headerGroups?.forEach((headerGroup) => {
      headerGroup?.headers?.forEach((header) => {
        const pinCondition = header?.column?.columnDef.pinCondition;
        if (pinCondition) {
          header?.column?.pin(pinCondition);
        }
      });
    });
  }, [headersArray.length]);

  return (
    <>
      <TableHead>
        {headerGroups.map((headerGroup) => {
          return (
            <TableRow
              style={{
                width: "100%",
                backgroundColor: "#fff",
                borderBottom: "2px solid red",
              }}
            >
              {headerGroup.headers.map((header) => {
                if (headerGroup.depth === 0) {
                  return (
                    <TableCell
                      colSpan={header.colSpan}
                      style={{ fontSize: "13px" }}
                      size="small"
                    >
                      {header.isPlaceholder
                        ? null
                        : flexRender(
                            header.column.columnDef.header,
                            header.getContext()
                          )}
                    </TableCell>
                  );
                } else {
                  return (
                    <HeaderCell
                      header={header}
                      stickRight={header.column.columnDef.id === "edit"}
                      table={table}
                      colSpan={header.colSpan}
                    />
                  );
                }
              })}
            </TableRow>
          );
        })}
      </TableHead>
    </>
  );
};
export default TableHeader;
